import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';

const tiers = [
  {
    id: 'member',
    label: 'Mission Ridge Member',
    amount: 20,
    envKey: 'REACT_APP_STRIPE_LOX_MEMBER_LINK',
  },
  {
    id: 'nonmember',
    label: 'Non-Member',
    amount: 30,
    envKey: 'REACT_APP_STRIPE_LOX_NONMEMBER_LINK',
  },
];

const LoxAndLoaded = () => {
  const [selectedTier, setSelectedTier] = useState(null);
  const [name, setName] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const canSubmit = name.trim().length > 0 && selectedTier !== null && !isProcessing;

  const handleSubmit = () => {
    if (!canSubmit) return;

    const tier = tiers.find((t) => t.id === selectedTier);
    const paymentLink = process.env[tier.envKey];

    if (!paymentLink) {
      alert('Payment link not configured yet. Please contact info@rangedrills.io');
      return;
    }

    setIsProcessing(true);

    sessionStorage.setItem(
      'loxRegistration',
      JSON.stringify({ name: name.trim(), tier: tier.label, amount: tier.amount })
    );

    window.location.href = paymentLink;
  };

  return (
    <Layout>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: '40px' }}>

          {/* Header */}
          <h2 className="major" style={{ textAlign: 'center', marginBottom: '4px' }}>
            Lox and Loaded
          </h2>
          <p style={{
            textAlign: 'center',
            fontSize: '0.9em',
            opacity: '0.6',
            marginTop: '0',
            marginBottom: '8px',
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
          }}>
            Powered by Range Drills
          </p>
          <p style={{
            textAlign: 'center',
            fontSize: '1.05em',
            opacity: '0.85',
            maxWidth: '560px',
            margin: '0 auto 36px',
          }}>
            Monthly range sessions for members of the Lox and Loaded shooting club.
            Select your membership status below to register.
          </p>

          {/* Name Input */}
          <div style={{ maxWidth: '480px', margin: '0 auto 28px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.95em', fontWeight: '600' }}>
              Your Name
            </label>
            <input
              type="text"
              placeholder="First and last name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                borderRadius: '8px',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                backgroundColor: 'rgba(255, 255, 255, 0.07)',
                color: '#fff',
                fontSize: '1em',
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>

          {/* Pricing Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '20px',
            maxWidth: '560px',
            margin: '0 auto 32px',
          }}>
            {tiers.map((tier) => {
              const isSelected = selectedTier === tier.id;
              return (
                <div
                  key={tier.id}
                  onClick={() => setSelectedTier(tier.id)}
                  style={{
                    padding: '28px 24px',
                    backgroundColor: 'rgba(27, 31, 34, 0.85)',
                    borderRadius: '10px',
                    border: isSelected ? '2px solid #FF5722' : '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: isSelected ? '0 6px 16px rgba(255, 87, 34, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.2)',
                    cursor: 'pointer',
                    textAlign: 'center',
                    transition: 'all 0.2s ease',
                    userSelect: 'none',
                  }}
                >
                  <div style={{
                    fontSize: '2.6em',
                    fontWeight: 'bold',
                    color: '#FF5722',
                    lineHeight: '1',
                    marginBottom: '10px',
                  }}>
                    ${tier.amount}
                  </div>
                  <div style={{ fontSize: '1em', fontWeight: '600', opacity: '0.9' }}>
                    {tier.label}
                  </div>
                  {isSelected && (
                    <div style={{
                      marginTop: '14px',
                      fontSize: '0.8em',
                      color: '#FF5722',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                    }}>
                      ✓ Selected
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Submit Button */}
          <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <button
              onClick={handleSubmit}
              disabled={!canSubmit}
              style={{
                padding: '14px 40px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: canSubmit ? '#FF5722' : '#555',
                color: '#fff',
                fontSize: '1.05em',
                fontWeight: 'bold',
                cursor: canSubmit ? 'pointer' : 'not-allowed',
                opacity: canSubmit ? 1 : 0.5,
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                if (canSubmit) {
                  e.target.style.backgroundColor = '#e64a19';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(255, 87, 34, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (canSubmit) {
                  e.target.style.backgroundColor = '#FF5722';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }
              }}
            >
              {isProcessing ? 'Redirecting...' : 'Proceed to Payment'}
            </button>
            <p style={{ marginTop: '12px', fontSize: '0.82em', opacity: '0.5' }}>
              Secured by Stripe
            </p>
          </div>

          {/* Event Details */}
          <div style={{
            maxWidth: '480px',
            margin: '0 auto 48px',
            padding: '22px 24px',
            backgroundColor: 'rgba(27, 31, 34, 0.85)',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.15)',
          }}>
            <h3 style={{ marginTop: '0', marginBottom: '16px', color: '#FF5722', fontSize: '1.1em', textAlign: 'center' }}>
              Event Details
            </h3>
            <div style={{ lineHeight: '1.9', fontSize: '0.95em' }}>
              <div><strong>When:</strong> Second Monday of every month, 6–8 PM</div>
              <div><strong>Where:</strong> Mission Ridge, Plano TX</div>
            </div>
          </div>

        </div>
      </section>
    </Layout>
  );
};

export default LoxAndLoaded;
